import type { IconData } from '@stacksjs/iconify-core'

export const listUiAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21.5 8h-14a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2m0 5h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2m0 5h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2\"/><circle cx=\"3.5\" cy=\"7\" r=\"1\" fill=\"currentColor\"/><circle cx=\"7.5\" cy=\"12\" r=\"1\" fill=\"currentColor\"/><circle cx=\"11.5\" cy=\"17\" r=\"1\" fill=\"currentColor\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default listUiAlt
